import socketConnector from 'sockets';
import _ from 'lodash';

let socket;

export function getSocketconnection(props) {

    if (!socket) {
        socket = socketConnector.connect(_.pick(props, ['userId']));
    }

    return socket;
}


// WEBPACK FOOTER //
// ./app/components/Issues/List/helpers.js